import type {
  DeviceViewSettingsTable,
  UsersMeSettingsPatchRequestBody,
  UsersMeSettingsResponseBody,
} from '@ipfabric/utils';
import type { DeviceViewEntity } from 'components/DeviceView/deviceViewTypes';
import { updateDeviceViewEntityTables } from 'components/DeviceView/helpers/updateDeviceViewEntityTables';
import type { DeviceViewCommandFactory } from '../DeviceViewModel';

export type UpdateDeviceViewSettings = (
  command: UpdateDeviceViewSettingsCommand,
) => void;

export interface UpdateDeviceViewSettingsCommand {
  selectedTables: DeviceViewSettingsTable[];
  deviceViewEntity: DeviceViewEntity;
}

export const updateDeviceViewSettings: DeviceViewCommandFactory<
  UpdateDeviceViewSettingsCommand
> = (cmdContext) => async (command) => {
  try {
    cmdContext.updateState((draft) => {
      draft.settings.saving = true;
    });
    const updatedSettings = updateDeviceViewEntityTables(
      command.deviceViewEntity,
      cmdContext.getState().settings,
      command.selectedTables,
    );
    const { _any, ...restNodes } = updatedSettings.nodes;
    await cmdContext.api.request<
      UsersMeSettingsResponseBody,
      UsersMeSettingsPatchRequestBody
    >({
      url: '/users/me/settings',
      method: 'PATCH',
      data: {
        diagrams: {
          tableSetup: {
            nodes: restNodes,
          },
        },
      },
    });
    cmdContext.updateState((draft) => {
      draft.settings.saving = false;
      draft.settings = updateDeviceViewEntityTables(
        command.deviceViewEntity,
        draft.settings,
        command.selectedTables,
      );
    });
  } finally {
    cmdContext.updateState((draft) => {
      draft.settings.saving = false;
    });
  }
};
